export default __webpack_public_path__ + "static/media/Screenshot1.af907411.png";